import { render } from "./AccesoSesion.vue?vue&type=template&id=fd887dd0"
import script from "./AccesoSesion.vue?vue&type=script&lang=js"
export * from "./AccesoSesion.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__